import { useState } from "react";
import {
  Box,
  Grid,
  Button,
  MenuItem,
  Select,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import SaveIcon from '@mui/icons-material/Save';
import SettingsEthernet from "@mui/icons-material/SettingsEthernet";
import { updateToastError } from "../utils/notification-loading";

const CustomFilters = ({ filterModel, setFilterModel }) => {
  const [filtersList, setFiltersList] = useState(getFiltersWithoutLogic(filterModel));
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  function getFiltersWithoutLogic(filtersList) {
    if (filtersList.length > 0 && filtersList[0].logic) {
      const updatedFilters = [
        { ...filtersList[0] }, // copia il primo oggetto
        ...filtersList.slice(1)
      ].map((f, index) => {
        // Rimuove 'logic' solo se è presente
        const { logic, ...rest } = f;
        return rest;
      });
      return updatedFilters;
    }
    // Se non c'è nulla da modificare, restituisce l'array originale
    return filtersList;
  }
  
  const [filters] = useState([
    {
      field: "ipSource",
      headerName: "SOURCE",
      operators: [
        { label: "contains", value: "contains" },
        { label: "not contains", value: "notContains" },
        { label: "equals", value: "equals" },
        { label: "not equals", value: "notEquals" }
      ],
    },
    {
      field: "MacSource",
      headerName: "SOURCE MAC",
      operators: [
        { label: "contains", value: "contains" },
        { label: "not contains", value: "notContains" },
        { label: "equals", value: "equals" },
        { label: "not equals", value: "notEquals" }
      ],
    },
        {
      field: "src_port",
      headerName: "SOURCE PORT",
      operators: [
        { label: "equals", value: "equals" },
        { label: "not equals", value: "notEquals" },
        { label: "range", value: "range" }
      ]
    },
    {
      field: "ipDestination",
      headerName: "DESTINATION",
      operators: [
        { label: "contains", value: "contains" },
        { label: "not contains", value: "notContains" },
        { label: "equals", value: "equals" },
        { label: "not equals", value: "notEquals" }
      ],
    },
    {
      field: "MacDestination",
      headerName: "DESTINATION MAC",
      operators: [
        { label: "contains", value: "contains" },
        { label: "not contains", value: "notContains" },
        { label: "equals", value: "equals" },
        { label: "not equals", value: "notEquals" }
      ],
    },
    {
      field: "dest_port",
      headerName: "DESTINATION PORT",
      operators: [
        { label: "equals", value: "equals" },
        { label: "not equals", value: "notEquals" },
        { label: "range", value: "range" }
      ]
    },
    {
      field: "dettaglio",
      headerName: "DETAILS",
      operators: [
        { label: "contains", value: "contains" },
        { label: "not contains", value: "notContains" },
        { label: "equals", value: "equals" },
        { label: "not equals", value: "notEquals" }
      ],
    },
    {
      field: "vlan",
      headerName: "VLANs",
      operators: [
        { label: "equals", value: "equals" },
        { label: "not equals", value: "notEquals" },
      ]
    },
    {
      field: "protocol",
      headerName: "PROTOCOL",
      operators: [
        { label: "equals", value: "equals" },
        { label: "not equals", value: "notEquals" },
      ]
    },
    {
      field: "app_proto",
      headerName: "APP PROTOCOL",
      operators: [
        { label: "equals", value: "equals" },
        { label: "not equals", value: "notEquals" },
      ]
    },
  ]);

  const protocolOptions = ["TCP", "UDP", "ICMP"];
  const appProtocolOptions = [
    "dns",
    "smb",
    "http",
    "snmp",
    "tls",
    "ike",
    "ikev2",
    "quic",
    "ssh",
    "dcerpc",
    "ftp",
    "rdp",
    "krb",
    "sip",
    "-",
  ];

  const isValidIp = (ip) => {
    const regex = /^([0-9.]+,?)*$/;
    return regex.test(ip);
  }

  const isValidMac = (mac) => {
    const regex = /^([0-9A-Fa-f]{0,2}([:-]?)){0,6}$/;
    return regex.test(mac);
  };

  const handleChange = (index, key, value) => {
    const updatedFilters = [...filtersList];
    if (value === "protocol" || value === "app_proto") updatedFilters[index].value = [];
    if (key === "value" && updatedFilters[index].field === "vlan") {
      const arrayString = value.split(",");
      const arrayNumber = arrayString.map(item => Number(item));
      updatedFilters[index].value = arrayNumber
    } else {
      updatedFilters[index][key] = value;
    }
    if (key === "field") {
      updatedFilters[index].operator = filters.find(f => f.field === value).operators[0].value
      updatedFilters[index].value = [];
    }
    setFiltersList(updatedFilters);
  };

  const handleChangeGroup = (indexGroup, index, key, value) => {
    const updatedFilters = [...filtersList];
    if (value === "protocol" || value === "app_proto")
      updatedFilters[indexGroup].filters[index].value = [];
    if (key === "value" && updatedFilters[indexGroup].filters[index].field === "vlan") {
      const ArrayString = value.split(",");
      updatedFilters[indexGroup].filters[index].value = Number(ArrayString.map(item => item.trim()));
    } else {
      updatedFilters[indexGroup].filters[index][key] = value;
    }
    if (key === "field") {
      updatedFilters[indexGroup].filters[index].operator = filters.find(f => f.field === value).operators[0].value
      updatedFilters[indexGroup].filters[index].value = [];
    }
    setSelectedGroup({ ...updatedFilters[indexGroup], pos: indexGroup });
    //setFiltersList(updatedFilters);
  }

  const handleAddFilter = () => {
    if(filtersList.length > 0) {
      const newFilter = {
        logic: "and",
        field: filters[1].field,
        operator: filters[1].operators[0].value,
        value: []
      };
      setFiltersList((prevFiltersList) => [...prevFiltersList, newFilter]);
    } else {
      setFiltersList([{ field: filters[0].field, operator: filters[0].operators[0].value, value: [] }]);
    }
    
  };

  const handleAddFilterGroup = (indexGroup) => {
    const newfilter = { logic: "and", field: filters[1].field, operator: filters[1].operators[0].value, value: [] };
    const group = filtersList[indexGroup]
    group.filters.push(newfilter)
    setFiltersList([...filtersList])
    filtersList[indexGroup] = group
    setSelectedGroup({ ...filtersList[indexGroup], pos: indexGroup })
  }

  const handleAddGroup = () => {
    const newFilter = {
      filters: [
        { field: filters[1].field, operator: filters[1].operators[0].value, value: [] },
        { logic: "and", field: filters[3].field, operator: filters[3].operators[0].value, value: [] }
      ]
    };
    if(filtersList.length > 0){
      newFilter.logic = "and"
    }
    setFiltersList((prevFiltersList) => [...prevFiltersList, newFilter]);
  }

  const handleDelete = (index) => {
    if(filtersList[index+1] && filtersList[index+1].filters && index === 0){
      return;
    }
    let newFilter = filtersList.filter((item, i) => i !== index);
    if (index === 0 && newFilter.length > 0) {
      const updatedFirst = { ...newFilter[0] };
      delete updatedFirst.logic;
      newFilter[0] = updatedFirst;
    }

    setFiltersList(newFilter);
  };

  const handleDeleteGroup = (indexGroup, index) => {
    const updatedFilters = [...filtersList];
    const newFilter = filtersList[indexGroup].filters.filter((item, i) => i !== index);
    updatedFilters[indexGroup].filters = newFilter;
    setSelectedGroup({ ...updatedFilters[indexGroup], pos: indexGroup });
    setFiltersList(updatedFilters);
  }

  const handleRemoveAll = () => {
    setFiltersList([]);
    setFilterModel([]);
  }

  const handleSave = () => {
    let check = true;
    try{
      filtersList.forEach((obj) => {
        if(!obj.filters){
          if(checkValue(obj.value)){
            check = false;
            updateToastError("Invalid filter value");
            return;
          }
        }
      })
    }catch(err){
      updateToastError("Invalid filter value");
    }
    if(check){
      setFilterModel(filtersList);
    }
  }

  const handleSaveGroup = (indexGroup) => {
    let check = true;
    selectedGroup.filters.forEach((filter) => {
      if(checkValue(filter.value)){
        check = false;
        return;
      }
    });
    if(check){
      const updatedFilters = [...filtersList];
      updatedFilters[indexGroup] = { ...selectedGroup };
      setFilterModel(updatedFilters);
      setDialogOpen(false);
    }
  }

  const checkValue = (value) => {
    if(value.length === 0 || value === "" || value === null || value === undefined){
      return true;
    }
    return false;
  }


  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "45vw"}}>
      {
        filtersList.length > 0 ? (
          filtersList.map((filter, index) => {
            return (
              <Box>
                <Grid container spacing={2} alignItems="center" sx={{ padding: 2, minWidth: "45vw" }}>
                  <Grid size={0.7}>
                    <IconButton
                    color="error"
                      onClick={() => handleDelete(index)}
                      sx={{ minWidth: 0, padding: "6px" }}>
                      <ClearIcon />
                    </IconButton>
                  </Grid>
                  {filter.logic ? (
                    <Grid size={1}>
                      <Select
                        label="LOGIC"
                        variant="standard"
                        fullWidth
                        value={filter.logic || ""}
                        onChange={(e) => handleChange(index, "logic", e.target.value)}
                      >
                        <MenuItem value="and">AND</MenuItem>
                        <MenuItem value="or">OR</MenuItem>
                      </Select>
                    </Grid>
                  ) : filtersList.length > 1 ? (
                    <Grid size={1}></Grid>
                  ) : (<></>)}

                  {filter.filters ? (
                    <>
                      <Grid size={2}>
                        <Button
                          fullWidth
                          variant="outlined"
                          size="large"
                          onClick={() => {
                            setSelectedGroup({ ...filtersList[index], pos: index })
                            setDialogOpen(true)
                          }}
                        >
                          OPEN GROUP
                        </Button>
                      </Grid>
                      <Grid size={8} overflowX={"auto"}>
                        <div style={{
                          paddingLeft: 10,
                          fontSize: "0.7rem",
                          display: "flex",
                          flexWrap: "nowrap",
                          overflowX: "auto",
                          whiteSpace: "nowrap",
                          maxWidth: "100%",

                        }}>
                          {filter.filters.map((f, i) => {
                            const filterMeta = filters.find((meta) => meta.field === f.field);
                            return (
                              <span key={i}>
                                {i !== 0 ? (`${f.logic?.toLowerCase()} `) : ""}
                                {filterMeta.headerName}: ${f.value || "EMPTY"}&nbsp;
                              </span>
                            )
                          })}
                        </div>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid size={2}>
                        <Select
                          label="column"
                          variant="standard"
                          sx={{ width: "100%" }}
                          value={filter.field || ""}
                          onChange={(e) => handleChange(index, "field", e.target.value)}
                        >
                          {filters.map((field) => {
                              return(
                                <MenuItem key={field.field} value={field.field}>
                                {field.headerName}
                                </MenuItem>
                              )
                          })}
                        </Select>
                      </Grid>

                      <Grid size={2}>
                        <Select
                          label="Operator"
                          variant="standard"
                          sx={{ width: "100%" }}
                          value={filter.operator || ""}
                          onChange={(e) => handleChange(index, "operator", e.target.value)}
                        >
                          {filters.find((item) => item.field === filter.field)?.operators?.map((operator, opIndex) => (
                            <MenuItem key={opIndex} value={operator.value}>
                              {operator.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>

                      <Grid size={6}>
                        {filter.field === "ipSource" ? (
                          <TextField
                            placeholder="SOURCE IP"
                            variant="standard"
                            sx={{ width: "100%" }}
                            value={filter.value}
                            onChange={(e) => handleChange(index, "value", e.target.value)}
                            error={Boolean(filter.value) && !isValidIp(filter.value)}
                            helperText={
                              filter.value && !isValidIp(filter.value)
                                ? "Invalid IP address (ex: 192.168.1.1)"
                                : ""
                            }
                          />
                        ) : filter.field === "MacSource" ? (
                          <TextField
                            placeholder="SOURCE MAC"
                            variant="standard"
                            sx={{ width: "100%" }}
                            value={filter.value}
                            onChange={(e) => handleChange(index, "value", e.target.value)}
                            error={Boolean(filter.value) && !isValidMac(filter.value)}
                            helperText={
                              filter.value && !isValidMac(filter.value)
                                ? "Invalid MAC address (ex: ff:ff:ff:ff:ff:ff)"
                                : ""
                            }
                          />
                        ) : filter.field === "ipDestination" ? (
                          <TextField
                            placeholder="DESTINATION IP"
                            variant="standard"
                            sx={{ width: "100%" }}
                            value={filter.value}
                            onChange={(e) => handleChange(index, "value", e.target.value)}
                            error={Boolean(filter.value) && !isValidIp(filter.value)}
                            helperText={
                              filter.value && !isValidIp(filter.value)
                                ? "Invalid IP address (ex: 192.168.1.1)"
                                : ""
                            }
                          />
                        ) : filter.field === "MacDestination" ? (
                          <TextField
                            placeholder="DESTINATION MAC"
                            variant="standard"
                            sx={{ width: "100%" }}
                            value={filter.value}
                            onChange={(e) => handleChange(index, "value", e.target.value)}
                            error={Boolean(filter.value) && !isValidMac(filter.value)}
                            helperText={
                              filter.value && !isValidMac(filter.value)
                                ? "Invalid MAC address (ex: ff:ff:ff:ff:ff:ff)"
                                : ""
                            }
                          />
                        ) : filter.field === "dettaglio" ? (
                          <TextField
                            placeholder="DETAIL"
                            variant="standard"
                            sx={{ width: "100%" }}
                            value={filter.value}
                            onChange={(e) => handleChange(index, "value", e.target.value)}
                          />
                        ) : filter.field === "protocol" ? (
                          <Select
                            variant="standard"
                            sx={{ width: "100%" }}
                            multiple
                            value={filter.value}
                            onChange={(e) => handleChange(index, "value", e.target.value)}
                            renderValue={(selected) => selected.join(", ")}
                          >
                            {protocolOptions.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : filter.field === "app_proto" ? (
                          <Select
                            variant="standard"
                            sx={{ width: "100%" }}
                            multiple
                            value={filter.value}
                            onChange={(e) => handleChange(index, "value", e.target.value)}
                          >
                            {appProtocolOptions.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : filter.field === "vlan" ? (
                          <TextField
                            variant="standard"
                            sx={{ width: "100%" }}
                            placeholder="VLAN (es: 10,20,30)"
                            value={filter.value}
                            onChange={(e) => handleChange(index, "value", e.target.value)}
                          />
                        ) : (filter.field === "src_port" || filter.field === "dest_port") && filter.operator !== "range" ? ( //filtri (eq, ne) su porte sorgete e destinazione 
                          <TextField
                            variant="standard"
                            sx={{ width: "100%" }}
                            placeholder="PORT (es: 80,8080,443)"
                            value={filter.value}
                            onChange={(e) => handleChange(index, "value", e.target.value)}
                          />
                        ) : (filter.field === "src_port" || filter.field === "dest_port") && filter.operator === "range" ? ( //filtro range su porte sorgete e destinazione
                          <TextField
                            variant="standard"
                            sx={{ width: "100%" }}
                            placeholder="PORT RANGE (es: 5000-5100)"
                            value={filter.value}
                            onChange={(e) => handleChange(index, "value", e.target.value)}
                          />
                        ) : (<></>)}
                      </Grid>
                    </>
                  )}
                </Grid>
              </Box>
            )
          })
        ):(
          <Typography sx={{ fontSize: 16, fontFamily: "poppins"}}>No filters</Typography>
        )
      } 
      <Grid container spacing={2} display="flex" justifyContent="space-between" alignItems="center" sx={{ padding: 1, width: '100%' }}>
        <Grid size={4} display="flex" gap={2}>
          <Button 
            sx={{
              fontFamily: "poppins", 
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: 12,
            }} 
            fullWidth 
            onClick={handleAddFilter}>
            <PlaylistAddIcon sx={{ marginRight: 1 }} /> ADD FILTER
          </Button>
          <Button
            sx={{
              fontFamily: "poppins",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: 12,
            }} 
            fullWidth 
            onClick={handleAddGroup}>
            <SettingsEthernet sx={{ marginRight: 1 }} /> ADD BRACKET
          </Button>
        </Grid>
        <Grid size={4} display="flex" gap={2} justifyContent="flex-end">
          <Button
            color="error"
            variant="contained"
            disabled={filtersList.length === 0}
            fullWidth
            onClick={handleRemoveAll}
            sx={{
              fontFamily: "poppins",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: 12,
              '&:hover': {
                backgroundColor: '#f44336 !important',
                opacity: 0.8,
              },
            }}
          >
            <DeleteForeverIcon fontSize="small" sx={{ marginRight: 1 }} />
            REMOVE ALL
          </Button>
          <Button
            sx={{
              fontFamily: "poppins",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: 12
            }} 
            fullWidth 
            onClick={handleSave}>
            <SaveIcon fontSize="small" sx={{ marginRight: 1 }} />APPLY FILTER
          </Button>
        </Grid>
      </Grid>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="50%">
        <DialogTitle>Group</DialogTitle>
        <DialogContent>
          {selectedGroup?.filters.map((filter, index) => (
            <Grid container spacing={2} alignItems="center" sx={{ padding: 2, minWidth: "50vw" }}>
              {filter.logic && index !== 1 ? (
                <Grid size={1}>
                  <IconButton color="error" onClick={() => handleDeleteGroup(selectedGroup.pos, index)}>
                    <ClearIcon />
                  </IconButton>
                </Grid>
              ) : (
                <Grid size={1}>
                  <IconButton color="error">
                    <ClearIcon />
                  </IconButton>
                </Grid>
              )}
              {filter.logic ? (
                <Grid size={1}>
                  <Select
                    label="LOGIC"
                    variant="standard"
                    fullWidth
                    value={filter.logic || ""}
                    onChange={(e) => handleChangeGroup(selectedGroup.pos, index, "logic", e.target.value)}
                  >
                    <MenuItem value="and">AND</MenuItem>
                    <MenuItem value="or">OR</MenuItem>
                  </Select>
                </Grid>
              ) : filtersList.length > 1 ? (
                <Grid size={1}></Grid>
              ) : (<></>)}
              <Grid size={3}>
                <Select
                  label="column"
                  variant="standard"
                  fullWidth
                  value={filter.field || ""}
                  onChange={(e) => handleChangeGroup(selectedGroup.pos, index, "field", e.target.value)}
                  sx={{ minWidth: 150 }}
                >
                  {filters.map((field) => (
                    <MenuItem key={field.field} value={field.field}>
                      {field.headerName}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid size={2}>
                <Select
                  label="Operator"
                  fullWidth
                  variant="standard"
                  value={filter.operator || ""}
                  onChange={(e) => handleChangeGroup(selectedGroup.pos, index, "operator", e.target.value)}
                  sx={{ minWidth: 100 }}
                >
                  {filters.find((item) => item.field === filter.field)?.operators?.map((operator, opIndex) => (
                    <MenuItem key={opIndex} value={operator.value}>
                      {operator.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid size={5}>
                {filter.field === "ipSource" ? (
                  <TextField
                    placeholder="IP SOURCE"
                    variant="standard"
                    sx={{ width: "100%" }}
                    value={filter.value}
                    onChange={(e) => handleChangeGroup(selectedGroup.pos, index, "value", e.target.value)}
                  />
                ) : filter.field === "ipDestination" ? (
                  <TextField
                    variant="standard"
                    sx={{ width: "100%" }}
                    value={filter.value}
                    onChange={(e) => handleChangeGroup(selectedGroup.pos, index, "value", e.target.value)}
                  />
                ) : filter.field === "dettaglio" ? (
                  <TextField
                    variant="standard"
                    sx={{ width: "100%" }}
                    value={filter.value}
                    onChange={(e) => handleChangeGroup(selectedGroup.pos, index, "value", e.target.value)}
                  />
                ) : filter.field === "protocol" ? (
                  <Select
                    variant="standard"
                    sx={{ width: "100%" }}
                    multiple
                    value={filter.value}
                    onChange={(e) => handleChangeGroup(selectedGroup.pos, index, "value", e.target.value)}
                    renderValue={(selected) => selected.join(", ")}
                  >
                    {protocolOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                ) : filter.field === "app_proto" ? (
                  <Select
                    variant="standard"
                    sx={{ width: "100%" }}
                    multiple
                    value={filter.value}
                    onChange={(e) => handleChangeGroup(selectedGroup.pos, index, "value", e.target.value)}
                    renderValue={(selected) => selected.join(", ")}
                  >
                    {appProtocolOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                ) : filter.field === "vlan" ? (
                  <TextField
                    variant="standard"
                    sx={{ width: "100%" }}
                    placeholder="Es. 10,100"
                    value={filter.value}
                    onChange={(e) => handleChangeGroup(selectedGroup.pos, index, "value", e.target.value)}
                  />
                ) : (<></>)}
              </Grid>
            </Grid>
          ))}
        </DialogContent>
        <DialogActions>
          <Grid container justifyContent="space-between" sx={{gap: 2}}>
            <Button
              onClick={() => { handleAddFilterGroup(selectedGroup.pos) }}>
              <PlaylistAddIcon /> &nbsp; ADD FILTER
            </Button>
            <Button onClick={() => handleSaveGroup(selectedGroup.pos)}>
              <SaveIcon fontSize="small" /> &nbsp; SAVE CHANGES
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </Box >
  )
};

export default CustomFilters;